interface PeachIconProps {
  size?: number;
  className?: string;
}

export default function PeachIcon({ size = 24, className }: PeachIconProps) {
  return (
    <svg width={size} height={size} viewBox="300 250 650 830" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Peach body — even-odd fill preserves the white crease gap */}
      <path
        fill="#FC8963"
        fillRule="evenodd"
        d="M898.353516,556.679810
           C910.171204,584.204468 916.843140,612.586487 919.194458,642.041321
           C922.361877,681.720154 918.111816,720.492004 905.167725,758.205566
           C892.637329,794.713928 873.633484,827.588196 848.635071,856.912842
           C820.690552,889.693420 787.177979,915.360474 748.266357,933.940857
           C719.763611,947.550903 689.904480,956.454285 658.497009,960.011536
           C598.833923,966.768982 543.301819,953.736084 491.226135,924.691650
           C435.721741,893.734924 394.225616,849.358276 365.929230,792.594238
           C352.684143,766.023804 343.747437,737.989380 339.503723,708.588013
           C330.696899,647.572571 339.740387,589.409851 368.719482,534.791565
           C388.417786,497.665253 415.756744,467.444000 452.336090,446.163269
           C475.433990,432.725586 500.433014,425.225433 527.067993,422.935608
           C550.858276,420.890381 573.837219,424.686462 596.381775,431.933197
           C599.843201,433.045868 603.161377,434.604492 607.382385,436.291199
           C601.779785,440.720184 596.762268,444.654022 591.779297,448.631165
           C559.732727,474.208893 536.003540,506.012177 520.037659,543.767517
           C503.905273,581.916382 496.954071,621.628784 500.253021,662.852356
           C503.465912,703.001160 516.265503,740.005371 539.975952,772.834900
           C548.313354,784.378845 558.345093,794.407043 570.548889,801.972351
           C572.119324,802.945862 574.409729,802.758057 576.366577,803.108154
           C576.066895,801.266663 576.286621,799.107910 575.386108,797.633240
           C567.401917,784.558533 558.987610,771.743042 551.143250,758.586914
           C534.723267,731.048401 524.113647,701.354187 520.396606,669.488586
           C516.503723,636.115784 520.061890,603.340759 530.333618,571.317017
           C543.577148,530.028198 565.827454,494.646667 599.468079,466.943390
           C630.469788,441.413239 665.499146,425.414764 706.126404,422.978912
           C755.859985,419.997009 798.623840,436.777191 835.949646,468.718658
           C863.965881,492.693512 883.853821,522.575867 898.353516,556.679810Z"
      />

      {/* Leaf */}
      <path
        fill="#53AD56"
        d="M659.047119,322.046509
           C686.331238,279.777618 726.145447,257.341095 774.103394,248.472610
           C791.352417,245.282898 809.115601,244.751160 826.675903,243.429047
           C833.573792,242.909698 835.053467,244.646545 834.805664,251.514648
           C833.037048,300.519653 813.068481,340.102295 773.100952,368.967316
           C750.545776,385.256989 724.691284,393.880951 697.734314,399.347961
           C674.354797,404.089539 651.331482,409.729279 629.564453,422.022125
           C630.912109,385.770508 639.633545,352.543121 659.047119,322.046509Z"
      />
    </svg>
  );
}
